import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { oneDark } from 'react-syntax-highlighter/dist/esm/styles/prism';
import type { Components } from 'react-markdown';

interface MarkdownProps {
  content: string;
  className?: string;
}

export const Markdown = ({ content, className = '' }: MarkdownProps) => {
  const components: Components = {
    code({ className, children, ...props }) {
      const match = /language-(\w+)/.exec(className || '');
      const isInline = !match;
      
      return isInline ? (
        <code className={className} {...props}>
          {children}
        </code>
      ) : (
        <SyntaxHighlighter
          // @ts-ignore - type error in react-syntax-highlighter
          style={oneDark}
          language={match[1]}
          PreTag="div"
          customStyle={{
            background: '#F9FAFB',
            padding: '1em',
            borderRadius: '0.375rem',
            fontSize: '14px',
          }}
          {...props}
        >
          {String(children).replace(/\n$/, '')}
        </SyntaxHighlighter>
      );
    },
  };

  return (
    <ReactMarkdown
      className={`prose prose-gray max-w-none ${className}`}
      remarkPlugins={[remarkGfm]}
      components={components}
    >
      {content}
    </ReactMarkdown>
  );
}; 